"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ACCESSIBLE_FRANCHISOR_PENDING = 'GET_ACCESSIBLE_FRANCHISOR_PENDING';
exports.GET_ACCESSIBLE_FRANCHISOR_ERROR = 'GET_ACCESSIBLE_FRANCHISOR_ERROR';
exports.GET_ACCESSIBLE_FRANCHISOR_SUCCESS = 'GET_ACCESSIBLE_FRANCHISOR_SUCCESS';
exports.GET_ACCESSIBLE_FRANCHISORS_PENDING = 'GET_ACCESSIBLE_FRANCHISORS_PENDING';
exports.GET_ACCESSIBLE_FRANCHISORS_ERROR = 'GET_ACCESSIBLE_FRANCHISORS_ERROR';
exports.GET_ACCESSIBLE_FRANCHISORS_SUCCESS = 'GET_ACCESSIBLE_FRANCHISORS_SUCCESS';
exports.SHOW_FORBIDDEN = 'SHOW_FORBIDDEN';
exports.HIDE_FORBIDDEN = 'HIDE_FORBIDDEN';
exports.GET_BASE_COLLECTION_PENDING = 'GET_BASE_COLLECTION_PENDING';
exports.GET_BASE_COLLECTION_ERROR = 'GET_BASE_COLLECTION_ERROR';
exports.GET_BASE_COLLECTION_SUCCESS = 'GET_BASE_COLLECTION_SUCCESS';
exports.PAGINATE_BASE_COLLECTION_PENDING = 'PAGINATE_BASE_COLLECTION_PENDING';
exports.PAGINATE_BASE_COLLECTION_SUCCESS = 'PAGINATE_BASE_COLLECTION_SUCCESS';
exports.SORT_BASE_COLLECTION_PENDING = 'SORT_BASE_COLLECTION_PENDING';
exports.SORT_BASE_COLLECTION_SUCCESS = 'SORT_BASE_COLLECTION_SUCCESS';
exports.UPDATE_BASE_COLLECTION_MODE = 'UPDATE_BASE_COLLECTION_MODE';
exports.SETUP_BASE_COLLECTION = 'SETUP_BASE_COLLECTION';
exports.FILTER_BASE_COLLECTION_PENDING = 'FILTER_BASE_COLLECTION_PENDING';
exports.FILTER_BASE_COLLECTION_SUCCESS = 'FILTER_BASE_COLLECTION_SUCCESS';
exports.SEARCH_BASE_COLLECTION_PENDING = 'SEARCH_BASE_COLLECTION_PENDING';
exports.SEARCH_BASE_COLLECTION_SUCCESS = 'SEARCH_BASE_COLLECTION_SUCCESS';
//# sourceMappingURL=constants.js.map